<template>
  <LoaderComponent />
  <div class="login-wrapper" v-if="isEntraLogin">

  </div>
  <div class="login-wrapper" v-if="!isEntraLogin">
    <div class="login-left">
      <h1 class="main-title">Welcome back to<br>Clementine Analytics</h1>
      <p class="main-subtitle">Secure access to your enterprise data and analytics</p>
    </div>

    <div class="login-right">
      <div class="login-right-content">
        <div class="login-header-text">
          <h2>Sign In</h2>
          <p>Access your secure workspace</p>
        </div>

        <form @submit="onLogin" class="w-100">
          <div class="form-floating-custom">
            <i class="fas fa-envelope input-icon"></i>
            <input name="email" id="loginEmail" placeholder=" " type="email" class="form-control" v-model="form.email"
              required autocomplete="email" />
            <label for="loginEmail">Email Address</label>
          </div>

          <div class="form-floating-custom">
            <i class="fas fa-lock input-icon"></i>
            <input type="password" name="password" id="loginPassword" placeholder=" " class="form-control"
              v-model="form.password" required autocomplete="current-password" />
            <label for="loginPassword">Password</label>
          </div>

          <div class="login-options">
            <div class="icheck-success">
              <input type="checkbox" id="rememberMe" v-model="rememberMe" />
              <label for="rememberMe">Remember Me</label>
            </div>
            <a class="forgot-password-link" @click="$router.push('/forget-password')">Forgot password?</a>
          </div>

          <button v-if="!isLoginLoader" type="submit" class="btn-login-main">Sign In</button>
          <button v-else class="btn-login-main" type="button" disabled>
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Signing in...
          </button>

          <div class="login-separator">
            <span>or sign in with</span>
          </div>

          <button type="button" class="btn-login-microsoft" @click="onMicrosoftLogin" :disabled="isLoginLoader">
            <img src="https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg" alt="Microsoft"
              style="height: 1.25em;" />
            <span>Sign in with Microsoft</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import agent, { masterServiceBaseURL } from '@/services/agent';
import { defineComponent } from 'vue';
import { Login, LoginResponse } from './Login.model';
import authService from '@/services/authService';
import router from '@/router/router';
import { LoginDTO } from '@/services/models/login';
import { useUserStore } from '@/store/useUserStore';
import localStore from '@/services/localStore';
import { AppConstants } from '@/shared/appConstants';
import { signInWithMicrosoft, handleMsalRedirect } from '@/services/msalHelper';
import preLoader from '@/services/preLoader';
import LoaderComponent from '../../../molecules/LoaderComponent.vue';
let _loginForm: Login = {} as Login;

export default defineComponent({
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  components: {
    LoaderComponent,
  },
  data() {
    return {
      form: _loginForm,
      isLoginLoader: false,
      isEntraLogin: false,
      rememberMe: false,
    }
  },
  created() {
    this.classAddRemove();
    agent.setBaseUrl(masterServiceBaseURL);
    this.RedirectTo();
    // Handle Microsoft Entra redirect result
    this.handleMicrosoftRedirect();
  },
  mounted() {
    this.form = {} as Login;
    // Pre-fill email if remembered
    const rememberedEmail = localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_REMEMBER_ME);
    if (rememberedEmail) {
      this.form.email = rememberedEmail;
      this.rememberMe = true;
    }
  },
  methods: {
    onLogin(event: any) {
      event.preventDefault();
      this.isLoginLoader = true;
      // Remember Me logic
      if (this.rememberMe) {
        localStore.setItem(AppConstants.LOCAL_STORAGE_KEY_REMEMBER_ME, this.form.email);
      } else {
        localStore.removeItem(AppConstants.LOCAL_STORAGE_KEY_REMEMBER_ME);
      }

      let post = { ...this.form };
      agent.postAnonymous<LoginResponse>(`v1/account/login`, post).then(async (response) => {
        authService.setJwtUser(response.result);
        this.isEntraLogin = true;
        preLoader.show();
        await this.userStore.ensurePagesLoaded();
        this.isLoginLoader = false;
        window.location.href = "/";
      })
        .catch(() => {
          this.isLoginLoader = false;
          this.isEntraLogin = false;
          preLoader.hide();
        });
    },
    RedirectTo() {
      const isExpired = authService.isExpired(authService.getToken());
      if (!isExpired) router.push("/");
    },
    classAddRemove() {
      var bodyElement = document.body;
      var sidbarminiClass = bodyElement.classList.contains("sidebar-mini");
      var layoutfixedClass = bodyElement.classList.contains("layout-fixed");
      var registerpageClass = bodyElement.classList.contains("register-page");
      if (sidbarminiClass) bodyElement.classList.remove('sidebar-mini');
      if (layoutfixedClass) bodyElement.classList.remove('layout-fixed');
      if (registerpageClass) bodyElement.classList.remove('register-page');
      //bodyElement.classList.add('register-page');
    },
    async onMicrosoftLogin() {
      try {
        await signInWithMicrosoft();
      } catch (e) {
        console.error('Microsoft login failed', e);
      }
    },
    async handleMicrosoftRedirect() {
      try {
        const msalResult = await handleMsalRedirect();
        if (msalResult && msalResult.accessToken) {
          this.isEntraLogin = true;
          preLoader.show();
          const response = await agent.postAnonymous<any>('v1/account/entra-login', { accessToken: msalResult.accessToken });
          if (response && response.result) {
            authService.setJwtUser(response.result);
            this.isEntraLogin = true;
            preLoader.show();
            await this.userStore.ensurePagesLoaded();
            window.location.href = "/";
          } else {
            this.isEntraLogin = false;
            preLoader.hide();
          }

        }
        preLoader.hide();
      } catch (e) {
        console.error('Microsoft login redirect failed', e);
        this.isEntraLogin = false;
        preLoader.hide();
      }
    },
  }
});
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

.login-wrapper {
  height: 100vh;
  display: flex;
  background-color: #fbfcfd;
  font-family: 'Plus Jakarta Sans', sans-serif;
  overflow: hidden;
}

.login-left {
  width: 45%;
  background: linear-gradient(135deg, #0a3370 0%, #03607A 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start; /* Changed to left align */
  padding: 5rem; /* Increased padding for more "breathability" */
  color: #ffffff;
  position: relative;
  overflow: hidden;
}

.login-left::before {
  content: "";
  position: absolute;
  top: -10%;
  right: -10%;
  width: 70%;
  height: 70%;
  background: radial-gradient(circle, rgba(73, 199, 235, 0.3) 0%, transparent 70%);
  border-radius: 50%;
  filter: blur(80px);
  z-index: 0;
}

.main-title {
  font-size: 3.25rem; /* Slightly smaller for elegance */
  font-weight: 700; /* Regular bold instead of extra heavy */
  letter-spacing: -1.5px;
  line-height: 1.2;
  text-align: left; /* Explicit left align */
  z-index: 1;
  color: #ffffff;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin: 0;
}

.main-subtitle {
  font-size: 1.15rem;
  font-weight: 400; /* Lighter weight for better hierarchy */
  color: rgba(255, 255, 255, 0.85);
  text-align: left; /* Explicit left align */
  margin-top: 2rem;
  z-index: 1;
  max-width: 90%;
  line-height: 1.6;
}

.login-right {
  width: 55%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
}

.login-right-content {
  width: 100%;
  max-width: 440px;
  padding: 3rem;
  animation: slideIn 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.login-header-text {
  margin-bottom: 2.5rem;
  text-align: center;
}

.login-header-text h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
}

.login-header-text p {
  color: #64748b;
  font-size: 0.95rem;
}

/* Floating Label implementation */
.form-floating-custom {
  position: relative;
  margin-bottom: 1.5rem;
}

.form-floating-custom .form-control {
  height: 60px;
  padding: 1.6rem 1rem 0.6rem 3.25rem;
  border-radius: 12px;
  border: 1.5px solid #e2e8f0;
  font-size: 1rem;
  transition: all 0.2s ease;
  background-color: #f8fafc;
  width: 100%;
  color: #1e293b;
}

.form-floating-custom .input-icon {
  position: absolute;
  left: 1.25rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 1.1rem;
  z-index: 2;
  transition: all 0.2s ease;
}

.form-floating-custom .form-control:focus~.input-icon {
  color: #03607A;
}

.form-floating-custom .form-control:focus {
  border-color: #03607A;
  background-color: #fff;
  box-shadow: 0 0 0 4px rgba(3, 96, 122, 0.1);
  outline: none;
}

.form-floating-custom label {
  position: absolute;
  top: 0;
  left: 3.25rem;
  padding: 1.1rem 0;
  pointer-events: none;
  transition: all 0.2s ease;
  color: #94a3b8;
  font-size: 1rem;
}

.form-floating-custom .form-control:focus~label,
.form-floating-custom .form-control:not(:placeholder-shown)~label {
  transform: translateY(-10px) scale(0.8) translate(-15%, 0);
  color: #03607A;
  font-weight: 700;
  background: transparent;
}

.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.icheck-success {
  display: flex;
  align-items: center;
  gap: 10px;
}

.icheck-success input[type="checkbox"] {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  cursor: pointer;
  accent-color: #03607A;
}

.icheck-success label {
  font-size: 0.9rem;
  color: #475569;
  cursor: pointer;
  margin-bottom: 0;
}

.btn-login-main {
  height: 56px;
  width: 100%;
  border-radius: 100px;
  background: #03607A;
  color: #ffffff;
  font-weight: 700;
  font-size: 1.1rem;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(3, 96, 122, 0.25);
  margin-bottom: 1.25rem;
}

.btn-login-main:hover {
  background: #024a5f;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(3, 96, 122, 0.35);
}

.login-separator {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 1.5rem 0;
  color: #94a3b8;
  font-size: 0.85rem;
  font-weight: 500;
}

.login-separator::before,
.login-separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #e2e8f0;
}

.login-separator span {
  padding: 0 1rem;
}

.btn-login-microsoft {
  height: 56px;
  width: 100%;
  border-radius: 100px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  color: #334155;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-login-microsoft:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.forgot-password-link {
  color: #64748b;
  font-size: 0.9rem;
  text-decoration: none;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.2s;
}

.forgot-password-link:hover {
  color: #03607A;
  text-decoration: underline;
}

@media screen and (max-width: 991px) {
  .login-left {
    display: none;
  }

  .login-right {
    width: 100%;
  }
}

/* ── Dark Mode ─────────────────────────────────────────── */
html.dark-mode .login-wrapper {
  background-color: #0d1117;
}

html.dark-mode .login-right {
  background: #161c2a;
}

html.dark-mode .login-header-text h2 {
  color: #e6edf3;
}

html.dark-mode .login-header-text p {
  color: #8b949e;
}

html.dark-mode .form-floating-custom .form-control {
  background-color: #1c2333;
  border-color: #30363d;
  color: #e6edf3;
}

html.dark-mode .form-floating-custom .form-control::placeholder {
  color: #8b949e;
}

html.dark-mode .form-floating-custom .form-control:focus {
  background-color: #253545;
  border-color: #0dcaf0;
  box-shadow: 0 0 0 4px rgba(13, 202, 240, 0.12);
  color: #e6edf3;
}

html.dark-mode .form-floating-custom label {
  color: #8b949e;
}

html.dark-mode .form-floating-custom .form-control:focus ~ label,
html.dark-mode .form-floating-custom .form-control:not(:placeholder-shown) ~ label {
  color: #0dcaf0;
}

html.dark-mode .form-floating-custom .input-icon {
  color: #8b949e;
}

html.dark-mode .icheck-success label {
  color: #8b949e;
}

html.dark-mode .forgot-password-link {
  color: #8b949e;
}

html.dark-mode .forgot-password-link:hover {
  color: #0dcaf0;
}

html.dark-mode .login-separator {
  color: #8b949e;
}

html.dark-mode .login-separator::before,
html.dark-mode .login-separator::after {
  border-bottom-color: #30363d;
}

html.dark-mode .btn-login-microsoft {
  background: #1c2333;
  border-color: #30363d;
  color: #c9d1d9;
}

html.dark-mode .btn-login-microsoft:hover {
  background: #253545;
  border-color: #8b949e;
}
</style>
